module.exports = __webpack_public_path__ + "img/icon3.597f1599.png";